import { request } from '@/apis/request';

const VERSION = '/v1.0.0'
const PRE_PATH = '/cBondIssuance/center';

// 查询日志列表
export function getLogInfoList(data) {
  return request({
    url: `${PRE_PATH}/LogInfoList${VERSION}`,
    method: 'post',
    data
  });
}
// 保存日志
export function saveLogInfo(data) {
  if(sessionStorage.getItem('URL_TYPE')==='center') return 
  return request({
    url: `${PRE_PATH}/LogInfoSave${VERSION}`,
    method: 'post',
    data
  });
}